<template>
  <v-dialog
    v-if="smAndDown"
    v-model="showMenu"
    fullscreen
    hide-overlay
    transition="dialog-top-transition"
    content-class="bg-background"
    class="bg-background"
  >
    <template v-slot:activator="{ props }">
      <v-avatar class="mr-3 mt-1" v-bind="props">
        <img v-if="avatarSrc" :src="avatarSrc"  width="100%" height="auto"/>
        <v-icon v-else icon="custom:avatar" size="100%" />
      </v-avatar>
    </template>
    <v-card class="bg-background">
      <v-toolbar flat class="bg-background">
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="showMenu = false">
            <v-icon color="grey-lighten-1">mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <AvatarMenuListContent @close="showMenu = false" />
    </v-card>
  </v-dialog>
  <!-- normal size avatar and menu -->
  <v-menu v-else v-model="showMenu" absolute offset-y content-class="rounded-lg">
    <template v-slot:activator="{ props }">
      <v-avatar class="mr-3 mt-1" v-bind="props" :size="small ? 40 : 60">
        <img v-if="avatarSrc" :src="avatarSrc"  width="100%" height="auto"/>
        <v-icon v-else icon="custom:avatar" size="100%" />
      </v-avatar>
    </template>
    <AvatarMenuListContent @close="showMenu = false" />
  </v-menu>
</template>
<script lang="ts" setup>
import { useUserStore } from '@/domains/user/userStore.ts';
import { computed, ref } from 'vue';
import { useDisplay } from 'vuetify';
import AvatarMenuListContent from './AvatarMenuListContent.vue';

const { small = false } = defineProps<{ small?: boolean }>()
const { smAndDown } = useDisplay()
const userStore = useUserStore()

const showMenu = ref(false)
const user = computed(() => userStore.getCurrentUser)
const avatarSrc = computed(() => user.value?.avatarURL)
</script>
